import React, { useState } from 'react'
import { Link,  } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import Hamburger from 'hamburger-react'
import logo from '../assests/Logo.png'

const Header = () => {
  const hamVW = 768;
  const [show, setShow] = useState(false);
  const handleClick = () => {
    setShow(prevOpen => !prevOpen);
  }
  return (
  // update
    <nav>
      <div className="nav">
       <div className='image'> 
      <img src={logo} />
      <h1>
      ather
      </h1>
      </div>
        {window.innerWidth < hamVW && <Hamburger class="ham" color="white" onToggle={t=>handleClick()} />}

        { (window.innerWidth > hamVW || show) &&
        <div class='nav-links'>
            <HashLink to={"/#home"}>Home</HashLink>
            <Link to={'/contact'}>Contact</Link>
            <HashLink to={'/#about'}>About</HashLink>
            <Link to={'/services'}>Services</Link>
        </div>}
      </div>
    </nav>
  )
}

export default Header